import React from 'react';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { weddingData } from '../data';

export const StorySection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section ref={ref} className="py-32 md:py-48 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -60 }}
            animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -60 }}
            transition={{ duration: 1, ease: "easeOut" }}
            className="relative"
          >
            <div className="aspect-[3/4] overflow-hidden rounded-sm">
              <img
                src={weddingData.coupleImage}
                alt="Surbhi & Ashish"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-8 -right-8 w-32 h-32 border border-stone-200 rounded-sm -z-10"></div>
          </motion.div>

          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, x: 60 }}
            animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 60 }}
            transition={{ duration: 1, ease: "easeOut", delay: 0.2 }}
            className="space-y-8"
          >
            {/* Overline */}
            <div className="flex items-center gap-4">
              <div className="h-px w-12 bg-stone-300"></div>
              <p className="text-xs uppercase tracking-widest text-stone-400">Chapter One</p>
            </div>

            {/* Heading */}
            <h2 className="font-elegant text-5xl md:text-6xl lg:text-7xl text-stone-900 leading-tight">
              Our Story
            </h2>

            {/* Story Text */}
            <div className="space-y-6 text-stone-600 text-lg md:text-xl leading-relaxed font-light">
              <p className="whitespace-pre-line">{weddingData.coupleStory}</p>
            </div>

            {/* Decorative Line */}
            <div className="pt-8">
              <div className="h-px w-24 bg-gradient-to-r from-stone-300 to-transparent"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
